import { render, staticRenderFns } from "./propagandaMonthlyStatistics.vue?vue&type=template&id=40838cc2"
import script from "./propagandaMonthlyStatistics.vue?vue&type=script&lang=js"
export * from "./propagandaMonthlyStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports